import React from 'react';
import { useIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import InfoTooltip from './InfoTooltip';
import { formatPercent, DASH } from './reportingFormat';
import messages from '../../../locale/jsonMessages';
import s from './OwnerReporting.css';

// Variation badge. The percentage and the trend come from the server (nothing is computed here):
// trend up / down / flat / new / none ; favorable true / false / null (inverted by the server where lower is better).
export const Variation = ({ indicator, compareLabel }) => {
  const { formatMessage, locale } = useIntl();
  if (!indicator) return null;
  const { trend, change, favorable } = indicator;
  let text;
  if (trend === 'new') text = formatMessage(messages.orpTrendNew);
  else if (trend === 'none' || change === null || change === undefined) text = DASH;
  else text = formatPercent(change, locale);
  const arrow = trend === 'up' || trend === 'new' ? '↑' : trend === 'down' ? '↓' : '';
  const tone = favorable === true ? s.variationGood : favorable === false ? s.variationBad : s.variationNeutral;
  return (
    <span>
      <span className={cx(s.variation, tone)}>{arrow && <span aria-hidden="true">{arrow}</span>}{text}</span>
      {compareLabel && <span className={s.compareLabel}>{compareLabel}</span>}
    </span>
  );
};

// KPI card: label, info bubble, formatted value, variation versus the previous period.
const KpiCard = ({ label, help, value, indicator, compareLabel, accent }) => (
  <div className={cx(s.card, accent && s.cardAccent)}>
    <p className={s.cardLabel}>{label}<InfoTooltip text={help} /></p>
    <p className={s.cardValue}>{value}</p>
    <Variation indicator={indicator} compareLabel={compareLabel} />
  </div>
);

export default withStyles(s)(KpiCard);
